let base_url = '';
let server_addr = '';
let kassa_addr = '';
let login_addr = '';


if (process.env.NODE_ENV === 'production') {
  // server_addr = 'https://176.223.142.146:8002';
  //server_addr = 'http://176.223.142.146:8000';

  server_addr ='https://16c62.l.time4vps.cloud:8005';
  kassa_addr = 'https://16c62.l.time4vps.cloud/pos';
  login_addr = 'https://ws.lwo.by:8243';

  // server_addr ='https://api-shop.lkassa.kz';
  // kassa_addr = 'https://shop.lkassa.kz/pos';
  // login_addr = 'https://api.lkassa.kz';
} else {
  // server_addr = 'https://176.223.142.146:8002';
  // server_addr = 'https://16c62.l.time4vps.cloud:8002';
  // server_addr ='https://api-shop.lkassa.kz';
  server_addr ='https://16c62.l.time4vps.cloud:8005';
  // server_addr = 'http://176.223.142.146:8000';
  //server_addr = 'http://localhost:8000';
  kassa_addr = 'https://16c62.l.time4vps.cloud/pos';
  //kassa_addr = 'http://localhost:3000/pos';
  login_addr = 'https://ws.lwo.by:8243';
}

let client_token = 'SlcyUmhsSURjYlNvekZrVDY2dmUxbmNxYzJQRlBLc0pqSXlkS2ZnRTpQVGx0ekFYZ1NDUFlzUGQybWpySTNPY3lra0lnNE9WVTIzSm9yNngzZHE5bEY0OHltUU92OFljcmpMaWtpTXpEd2V0WkVyVk9taHpqa2xUTXh3VlF1Vmh2bEUwelFwTTVQVDB1T2ZHcTBjMVgwazRJaFdmbkNxelpRZjlHOTNWMQ==';
base_url = server_addr + '/api/v1';
export {base_url, server_addr, client_token, kassa_addr, login_addr};



// WEBPACK FOOTER //
// ./src/http.js